export const itemsDenounce = [
  {
    key: "1",
    labelPT: "Spam",
    labelEN: "Spam"
  },
  {
    key: "2",
    labelPT: "Assédio ou bullying",
    labelEN: "Harassment or bullying"
  },
  {
    key: "3",
    labelPT: "Discurso de ódio",
    labelEN: "Hate speech"
  },
  {
    key: "4",
    labelPT: "Dados pessoais",
    labelEN: "Personal data"
  },
  {
    key: "5",
    labelPT: "Conteúdo ofensivo",
    labelEN: "Offensive content"
  },
  {
    key: "6",
    labelPT: "Outros",
    labelEN: "Others"
  },
]